import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Placeholder from "react-bootstrap/Placeholder";

const summaryCards = [
  {
    key: "rent",
    title: "Rent Paying Tenants",
    dataKey: "totalRentTenantCount",
    icon: "bi-person-check-fill",
    accent: "#2e7d32",
    soft: "rgba(46, 125, 50, 0.12)",
  },
  {
    key: "nonRent",
    title: "Non-Rent Paying Tenants",
    dataKey: "totalNonRentTenantCount",
    icon: "bi-person-dash-fill",
    accent: "#c62828",
    soft: "rgba(198, 40, 40, 0.12)",
  },
  {
    key: "landlord",
    title: "Landlords / Agents",
    dataKey: "totalLandlordCount",
    icon: "bi-buildings-fill",
    accent: "#1565c0",
    soft: "rgba(21, 101, 192, 0.12)",
  },
];

const SummaryCards = ({ loading, graphdata }) => {
  if (loading) {
    return (
      <Row className="g-3 mb-4">
        {summaryCards.map((card) => (
          <Col lg={4} md={12} key={card.key}>
            <Card
              className="h-100 border-0"
              style={{
                borderRadius: "10px",
                padding: "16px",
                overflow: "hidden",
                boxShadow: "0 6px 18px rgba(15, 23, 42, 0.06)",
              }}
            >
              <Card.Body className="p-4">
                <div className="d-flex justify-content-between align-items-start gap-3">
                  <div style={{ flex: 1 }}>
                    <Placeholder as="div" animation="glow">
                      <Placeholder
                        xs={7}
                        bg="light"
                        style={{
                          height: "12px",
                          borderRadius: "999px",
                          opacity: 0.6,
                        }}
                      />
                    </Placeholder>
                    <Placeholder as="div" animation="glow" style={{ marginTop: "12px" }}>
                      <Placeholder
                        xs={5}
                        bg="light"
                        style={{
                          height: "32px",
                          borderRadius: "8px",
                          opacity: 0.6,
                        }}
                      />
                    </Placeholder>
                  </div>
                  <Placeholder animation="glow">
                    <div
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "12px",
                        backgroundColor: "#f8fafc",
                        opacity: 0.8,
                      }}
                    />
                  </Placeholder>
                </div>
              </Card.Body>
              <div
                style={{
                  height: "4px",
                  width: "100%",
                  marginTop: "16px",
                  backgroundColor: "#f8fafc",
                }}
              />
            </Card>
          </Col>
        ))}
      </Row>
    );
  }

  return (
    <Row className="g-3 mb-4">
      {summaryCards.map((card) => (
        <Col lg={4} md={12} key={card.key}>
          <Card
            className="h-100 dashboard-summary-card border-0"
            style={{
              borderRadius: "10px",
              padding: "16px",
              overflow: "hidden",
            }}
          >
            <Card.Body className="p-4">
              <div className="d-flex justify-content-between align-items-start gap-3">
                <div>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "0.78rem",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.08em",
                      color: "#64748b",
                    }}
                  >
                    {card.title}
                  </p>
                  <h3
                    style={{
                      margin: "12px 0 0 0",
                      fontWeight: 700,
                      fontSize: "2rem",
                      color: "#0f172a",
                      lineHeight: 1.1,
                    }}
                  >
                    {graphdata?.[card.dataKey] || 0}
                  </h3>
                </div>
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: card.soft,
                    color: card.accent,
                    flexShrink: 0,
                  }}
                >
                  <i className={`bi ${card.icon}`} style={{ fontSize: "1.2rem" }} />
                </div>
              </div>
            </Card.Body>
            <div
              style={{
                height: "4px",
                width: "100%",
                marginTop: "16px",
                background: `linear-gradient(90deg, ${card.accent}, rgba(255,255,255,0))`,
              }}
            />
          </Card>
        </Col>
      ))}
      <style>
        {`
          .dashboard-summary-card {
            transition: transform 0.2s ease, box-shadow 0.2s ease;
          }
        `}
      </style>
    </Row>
  );
};

export default SummaryCards;
